import { createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '~/domains/design-system/Button';
import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import { Text } from '~/domains/design-system/Text';
import { Title } from '~/domains/design-system/Title';
import { toSafeMarkup } from '~/domains/common/utils/toSafeMarkup';
import { getLinkStyles } from '~/domains/common/components/Link/Link';

import {
  ContestManageModalBody,
  ContestManageModalDelimiter,
  ContestManageModalOrderedList,
  ContestManageModalOrderedListItem,
  ContestManageModalTitle,
} from '../commonStyles';

const useStyles = createStyles((theme) => ({
  button: {
    marginTop: theme.other.spacing._32,
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,

    '& a': {
      ...getLinkStyles(theme),
    },
  },
}));

function CollectEntryFeesInfoModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const { classes, theme } = useStyles();
  const { t } = useTranslation('contest');

  return (
    <Dialog
      type={{
        desktop: 'modal',
        mobile: 'modal-full-screen',
      }}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ContestManageModalBody>
        <ContestManageModalTitle>
          {t('manage.common.modals.collectEntryFeesInfoModal.title')}
        </ContestManageModalTitle>
        <ContestManageModalOrderedList>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.collectEntryFeesInfoModal.list.1.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.collectEntryFeesInfoModal.list.1.description')}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.collectEntryFeesInfoModal.list.2.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.collectEntryFeesInfoModal.list.2.description')}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
          <ContestManageModalOrderedListItem>
            <div>
              <Title variant="title-large">
                {t('manage.common.modals.collectEntryFeesInfoModal.list.3.title')}
              </Title>
              <Text variant="body-large" color={theme.colors.gray2[3]}>
                {t('manage.common.modals.collectEntryFeesInfoModal.list.3.description')}
              </Text>
            </div>
          </ContestManageModalOrderedListItem>
        </ContestManageModalOrderedList>
        <ContestManageModalDelimiter />
        <div className={classes.footer}>
          <Text variant="body-medium" color={theme.colors.gray2[3]}>
            {t('manage.common.modals.collectEntryFeesInfoModal.footer.1')}
          </Text>
          <Text variant="body-medium" color={theme.colors.gray2[3]}>
            {t('manage.common.modals.collectEntryFeesInfoModal.footer.2')}
          </Text>
        </div>
        <Button variant="primary-fill" fullWidth className={classes.button} onClick={onClose}>
          {t('manage.common.modals.collectEntryFeesInfoModal.cta')}
        </Button>
      </ContestManageModalBody>
    </Dialog>
  );
}

export default CollectEntryFeesInfoModal;
